
import InternalOrderManagement from "pages/order-internal";
import { lazy } from "react";
const OrderManagement = lazy(
  () => import("pages/OrderManagement/OrderManagement")
);
const OrderReceipt = lazy(() => import("pages/order-receipt"));
const OrderInPerson = lazy(() => import("pages/order-in-person"));
export const childs: Array<ISideBarChild> = [
  {
    code: "",
    to: "/order-management",
    component: <OrderManagement />,
    label: " مدیریت سفارش",
    permissions: "view_order_management",
  },
  {
    code: "",
    to: "order-receipt",
    component: <OrderReceipt />,
    label: "رسید دریافت ",
    permissions: "receipt",
  },
  {
    code: "",
    to: "order-in-person",
    component: <OrderInPerson />,
    label: "دریافت مرسوله های حضوری ",
    permissions: "inperson_Recieve_consignment",
  },
  {
    code: '',
    to: 'internal-order',
    component: <InternalOrderManagement />,
    label: 'سفارشات درون سازمانی ',
    permissions: 'view_inner_order',
  },
];
